import { createApp, App } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { createPinia } from 'pinia'
import { createApplication } from '@/app'

import './styles/index.sass'


export const app = createApplication({
  createApp, createRouter, createWebHistory, createPinia,
})

window.app = app

declare global {
  interface Window {
    // USER_PERMISSIONS: any
    // ALL_PERMISSIONS: any
    userRole: string,
    logo_main: string,
    logo_alternative: string,
    languagesList: Array<object>,
    isAuth: boolean,
    language: string
    app: App
    isSuperUser: boolean,
    captcha_key: string,
    userStatuses: object,
    moderationStatuses: object,
    articleStatuses: object,
    bonusTypes: object,
    motivationStatuses: object,
  }
}

